<h2 mat-dialog-title>

  <mat-icon>qr_code_2</mat-icon>

  QR-Codes erstellen

</h2>


<mat-dialog-content class="qr-admin">

  <p class="hinweis">
    Erstellt freie QR-Codes, die später beim Scannen einer
    Messstelle zugeordnet werden.
  </p>


  <div class="generator">

    <mat-form-field appearance="outline">

      <mat-label>
        Anzahl
      </mat-label>

      <input
        matInput
        type="number"
        min="1"
        max="650"
        [(ngModel)]="anzahl">

      <mat-hint>
        1 bis 650 Codes
      </mat-hint>

    </mat-form-field>


    <div class="schnellwahl">

      <span class="schnellwahl-label">
        Ganze Bögen:
      </span>

      <button
        mat-stroked-button
        type="button"
        *ngFor="let bogen of [1, 2, 5, 10]"
        [disabled]="loading"
        (click)="aufVolleBogen(bogen)">

        {{ bogen }}
        ({{ bogen * etikettenProBogen }})

      </button>

    </div>

  </div>


  <!-- BEDARF -->
  <div
    class="bedarf"
    *ngIf="eingabeGueltig">

    <mat-icon>description</mat-icon>

    <span>

      Benötigt

      <strong>
        {{ bogenVorschau }}
      </strong>

      {{ bogenVorschau === 1 ? 'Etikettbogen' : 'Etikettbögen' }}

      à {{ etikettenProBogen }} Etiketten (5 × 13, A4).

    </span>

  </div>


  <div
    class="fehler"
    *ngIf="fehler">

    <mat-icon>error_outline</mat-icon>

    <span>
      {{ fehler }}
    </span>

  </div>


  <!-- ERGEBNIS -->
  <div
    class="ergebnis"
    *ngIf="generiert.length > 0">

    <mat-icon color="primary">
      check_circle
    </mat-icon>

    <div class="ergebnis-text">

      <strong>
        {{ generiert.length }} QR-Codes wurden erstellt.
      </strong>

      <span>

        {{ bogenErzeugt }}

        {{ bogenErzeugt === 1 ? 'Etikettbogen' : 'Etikettbögen' }}

        werden benötigt<ng-container *ngIf="restEtiketten > 0">,
          auf dem letzten Bogen bleiben
          {{ restEtiketten }} Etiketten frei</ng-container>.

      </span>

    </div>

  </div>


  <!-- FORMATANGABEN -->
  <div class="format">

    <span class="format-hinweis">
      Beim Druck muss die Skalierung auf
      „Tatsächliche Größe“ / 100 % stehen.
    </span>

  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">

  <button
    mat-button
    type="button"
    (click)="schliessen()">

    Schließen

  </button>


  <button
    mat-stroked-button
    type="button"
    *ngIf="generiert.length > 0"
    (click)="exportieren()">

    <mat-icon>download</mat-icon>

    PDF exportieren

  </button>


  <button
    mat-stroked-button
    type="button"
    *ngIf="generiert.length > 0"
    (click)="drucken()">

    <mat-icon>print</mat-icon>

    Drucken

  </button>


  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="loading || !eingabeGueltig"
    (click)="generieren()">

    <mat-icon>qr_code_2</mat-icon>

    {{
      loading
        ? 'Wird erstellt …'
        : 'QR-Codes generieren'
    }}

  </button>

</mat-dialog-actions>
